<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    //
    import assetStockApi from '../../api/asset'

    export default {
        name: 'swb-depr-spec-list-for-select',
        desc: '折旧规格',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return null;
                }
            }
        },
        data: function () {
            return {
                confKey: "swb-depr-spec-list-for-select",
                theTableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）

                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 150,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                dataList: [],
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                allotAcntMethodMap: getEnumMap('allotAcntMethod', 'value2text'),
                deprAllocCCWayMap: getEnumMap('deprAllocCCWay', 'value2text')
            }
        },
        created: function () {

        },
        mounted() {
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let assetNatureList = getEnumList("assetNature");
                if (assetNatureList.length > 0) {
                    let dataList = [{value: null, label: "- 全部 -"}];
                    for (let i = 0; i < assetNatureList.length; i++) {
                        let item = assetNatureList[i];
                        dataList.add({
                            value: item.value,
                            label: item.text
                        });
                    }
                    query_model_ctrl.updateFields({
                        assetNature: {
                            dataList: dataList
                        }
                    });
                }
                let allotAcntMethodList = getEnumList("allotAcntMethod");
                if (allotAcntMethodList.length > 0) {
                    let dataList = [{value: null, label: "- 全部 -"}];
                    for (let i = 0; i < allotAcntMethodList.length; i++) {
                        let item = allotAcntMethodList[i];
                        if (item.value != 0) {
                            dataList.add({
                                value: item.value,
                                label: item.text
                            });
                        }
                    }
                    query_model_ctrl.updateFields({
                        allotAcntMethod: {
                            dataList: dataList
                        }
                    });
                }
                let assetDeprMethodList = getEnumList("assetDeprMethod");
                if (assetDeprMethodList.length > 0) {
                    let dataList = [{value: null, label: "- 全部 -"}];
                    for (let i = 0; i < assetDeprMethodList.length; i++) {
                        let item = assetDeprMethodList[i];
                        dataList.add({
                            value: item.name,
                            label: item.text
                        });
                    }
                    query_model_ctrl.updateFields({
                        deprMethodCode: {
                            dataList: dataList
                        }
                    });
                }
                //
                let deprAllocCCWayList = getEnumList("deprAllocCCWay");
                if (deprAllocCCWayList.length > 0) {
                    let dataList = [{value: null, label: "- 全部 -"}];
                    for (let i = 0; i < deprAllocCCWayList.length; i++) {
                        let item = deprAllocCCWayList[i];
                        if (item.value != 0) {
                            dataList.add({
                                value: item.value,
                                label: item.text
                            });
                        }
                    }
                    query_model_ctrl.updateFields({
                        deprAllocCCWay: {
                            dataList: dataList
                        }
                    });
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'assetNature': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.assetNatureMap[row.assetNature] + '</span>';
                    },
                    'deprOn1stMonth': function (row, colName, colValue, rowIndex) {
                        if (row.deprMethodCode == 'SLD' || row.deprMethodCode == 'ASM') {
                            return colValue ? '首月' : '次月';
                        }
                    },
                    'rmnWorthRatio': function (row, colName, colValue, rowIndex) {
                        if (row.deprMethodCode == 'SLD' || row.deprMethodCode == 'ASM') {
                            return colValue;
                        }
                    },
                    'allotAcntMethod': function (row, colName, colValue, rowIndex) {
                        if (colValue != 0) {
                            return '<span>' + self.allotAcntMethodMap[colValue] + '</span>';
                        }
                    },
                    'transWorthRatio': function (row, colName, colValue, rowIndex) {
                        if (row.allotAcntMethod == 2) {
                            return colValue;
                        }
                    },
                    'deprAllocCCWay': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.deprAllocCCWayMap[colValue] + '</span>';
                    },
                    'autoDeprDay': function (row, colName, colValue, rowIndex) {
                        if (colValue != 0) {
                            return '<span>' + colValue + '</span>';
                        }
                    },
                    'allowedMaxOrgWorth': function (row, colName, colValue, rowIndex) {
                        if (colValue != 0) {
                            return '<span>' + colValue + '</span>';
                        }
                    },
                    'allowedMaxRmnWorth': function (row, colName, colValue, rowIndex) {
                        if (colValue != 0) {
                            return '<span>' + colValue + '</span>';
                        }
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getDataList();
            },
            getDataList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let filter = this.filter;
                if (!Utils.isNoB(filter)) {
                    filterItems = Object.assign(filterItems, filter);
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                assetStockApi.getDeprSpecPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let data = result.data;
                        self.dataList = data.rows;
                        self.totalCount = data.pagination.totalCount;
                        self.renderTable(self.dataList, data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let select = this.getTableSelection() || [];
                //
                let result = {};
                if (Utils.isNoB(select)) {
                    result.type = "warn";
                    result.message = "请选择折旧规格！";
                } else {
                    result.type = "info";
                    result.data = select;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/DeprSpecListForSelect.vue